"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var Claims_1 = require("./Claims");
var ClaimsPagePlain = /** @class */ (function (_super) {
    __extends(ClaimsPagePlain, _super);
    function ClaimsPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.handleDriverChange = function (event) {
            var person = _this.state.uniqueDrivers.find(function (d) { return d.name === event.target.value; });
            _this.setState({ selectedDriver: person });
        };
        _this.state = {
            involvedObjects: [],
            selectedDriver: _this.props.location.state && _this.props.location.state.selectedDriver,
            uniqueDrivers: [],
        };
        document.title = "Claims";
        return _this;
    }
    ClaimsPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        var drivers = [];
        this.supportPortalService.getSubscriptionDrivers(this.props.params.id).subscribe(function (involvedObjects) {
            var _loop_1 = function (object) {
                var driver = drivers.find(function (d) { return d.name === object.firstName + " " + object.lastName; });
                if (driver) {
                    driver.driverIds.push(object.objectId);
                }
                else {
                    drivers.push({
                        name: object.firstName + " " + object.lastName,
                        driverIds: [object.objectId]
                    });
                }
            };
            for (var _i = 0, involvedObjects_1 = involvedObjects; _i < involvedObjects_1.length; _i++) {
                var object = involvedObjects_1[_i];
                _loop_1(object);
            }
            _this.setState({
                involvedObjects: involvedObjects,
                uniqueDrivers: drivers
            });
        });
    };
    ClaimsPagePlain.prototype.render = function () {
        if (this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler"])) {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.supportPortalTemplates.renderBackLink("Search page", true, "/customers/".concat(this.props.params.id)), (0, jsx_runtime_1.jsxs)("div", { className: "panel-border", children: [(0, jsx_runtime_1.jsxs)("div", { className: "col-12 col-md-8 my-3", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "driver", children: "Select person for which you want to manage claims" }), (0, jsx_runtime_1.jsxs)("select", { id: "driver", className: "form-control", name: "driver", value: this.state.selectedDriver && this.state.selectedDriver.name, onChange: this.handleDriverChange, children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Please choose..." }), this.renderDriverOptions()] })] }), this.state.selectedDriver && ((0, jsx_runtime_1.jsx)(Claims_1.default, __assign({}, this.props, { selectedDriver: this.state.selectedDriver })))] })] }));
        }
        else {
            return this.supportPortalTemplates.renderErrorPage();
        }
    };
    ClaimsPagePlain.prototype.renderDriverOptions = function () {
        return this.state.uniqueDrivers.map(function (driver, index) { return ((0, jsx_runtime_1.jsx)("option", { value: driver.name, children: driver.name }, index)); });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], ClaimsPagePlain.prototype, "supportPortalService", void 0);
    ClaimsPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], ClaimsPagePlain);
    return ClaimsPagePlain;
}(React.Component));
exports.ClaimsPagePlain = ClaimsPagePlain;
exports.default = (0, components_1.withRouter)(ClaimsPagePlain);
//# sourceMappingURL=ClaimsPage.js.map